
import cell from './mixins/cell'

import Sort from './head/sort'

import Value from './types/label/base'
import Expand from './types/label/expand'
import Index from './types/label/index'
import Selection from './types/label/selection'

const justify = {
  center: 'center',
  left: 'start',
  right: 'end'
}

export default {
  name: 'VsTableHead',
  mixins: [cell],
  components: {
    Sort,
    Value,
    Expand,
    Index,
    Selection
  },
  computed: {
    justify() {
      return justify[this.align]
    },
    isDark() {
      return this.table.darkHeader
    },
    canClick() {
      return this.table.hasData && this.sortable
    }
  },
  methods: {
    onClick(event) {
      if (this.canClick) {
        this.$refs.sort.onClick(event)
      }
    },
    onSortChange(order) {
      const prop   = this.prop
      const column = this.$props

      this.table.$emit('sort-change', { column, prop, order })
    }
  }
}
